import { B2BSubnav } from '@zillow/zrs-cms';
import React from 'react';

interface MenuItem {
    id: string | number;
    title: { rendered: string; raw?: string } | string;
    url: string;
    parent: string | number;
}

interface LearningCenterSubnavProps {
    menu: {
        meta?: {
            title?: string;
            url?: string;
            search?: string;
        };
        items: MenuItem[];
    };
}

const LearningCenterSubnav: React.FC<LearningCenterSubnavProps> = ({
    menu,
}) => <B2BSubnav menu={menu} searchPlaceholder="Search Learning Center" />;

export default LearningCenterSubnav;
